import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    payments: [],
    stats: null,
    revenueByAdmin: [],
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setPayments: (state, action) => {
            state.payments = action.payload;
        },
        setStats: (state, action) => {
            state.stats = action.payload;
        },
        setRevenueByAdmin: (state, action) => {
            state.revenueByAdmin = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const {
    setPayments,
    setStats,
    setRevenueByAdmin,
    setPagination,
    setLoading,
    setError,
    clearError,
} = paymentSlice.actions;

export default paymentSlice.reducer;
